import { Component } from '@angular/core';
import { BRAND_CONFIG } from '../brand.config';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  brand = BRAND_CONFIG;
}
